export const devWarning = {
  pt: {
    devWarning: "Esta é uma ferramenta em fase de testes em desenvolvimento.",
  },
  en: {
    devWarning: "This tool is currently in development and under testing.",
  },
};